<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Tworzenie listu przewozowego
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-menu
                                v-model="deliveryDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="complaintReturnDetails.plannedReturnDate"
                                        label="Planowana data zwrotu"
                                        prepend-inner-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        outlined
                                        :error-messages="plannedReturnDateErrors"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="complaintReturnDetails.plannedReturnDate"
                                    first-day-of-week="1"
                                    @input="deliveryDate = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="complaintReturnDetails.packageNumber"
                                label="Numer listu przewozowego"
                                outlined
                                :error-messages="packageNumberErrors"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveComplaintReturnNumber()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import tooltipDelay from '@/mixins/tooltip'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ComplaintReturnDialog',
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        currentComplaint: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            packageNumberDialog: false,
            complaintReturnDetails: {
                packageNumber: null,
                plannedReturnDate: null
            },
            deliveryDate: false,
            complaint: {}
        }
    },
    validations: {
        complaintReturnDetails: {
            packageNumber: {
                required
            },
            plannedReturnDate: {
                required
            }
        }
    },
    computed: {
        packageNumberErrors() {
            const errors = []

            if (!this.$v.complaintReturnDetails.packageNumber.$dirty) return errors
            !this.$v.complaintReturnDetails.packageNumber.required && errors.push('Proszę podać numer listu przewozowego.')

            return errors
        },
        plannedReturnDateErrors() {
            const errors = []

            if (!this.$v.complaintReturnDetails.plannedReturnDate.$dirty) return errors
            !this.$v.complaintReturnDetails.plannedReturnDate.required && errors.push('Proszę podać planowaną datę zwrotu.')

            return errors
        }
    },
    watch: {
        isOpen() {
            this.complaint = JSON.parse(JSON.stringify(this.currentComplaint))
            this.clearComplaintReturnDetails()
        }
    },
    methods: {
        saveComplaintReturnNumber() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.complaint.complaintReturnNumber.push({
                packageNumber: this.complaintReturnDetails.packageNumber,
                plannedReturnDate: `${this.complaintReturnDetails.plannedReturnDate}T00:00:00Z`,
                returned: false
            })

            this.$emit('on-confirm', this.complaint)
        },
        onClose() {
            this.$emit('on-close')
        },
        clearComplaintReturnDetails() {
            setTimeout(() => {
                this.$v.$reset()
                this.complaintReturnDetails = {
                    packageNumber: null,
                    plannedReturnDate: null
                }
            }, 500)
        }
    }
}
</script>

